import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import TagChips from '../TagChips';

// Çoklu seçimli CSV süzgeci (`<ad>[in]=a,b`). Aday listesi, havuz üyeleri ve etiket
// kolonu AYNI bileşeni kullanır. `valueRender` seçenek etiketi; `filterKey` verilirse
// parseTableParams kolon adı yerine onu gönderir (ör. tags kolonu → `tagId[in]`).
export const multiSelectFilter = (label, options, valueRender, filterKey) => ({
  filter: true,
  sort: true,
  filterType: 'custom',
  filterOptions: {
    defaultOp: 'in',
    ...(filterKey ? { filterKey } : {}),
    display: (filterList, onChange, index, column) => {
      const current = filterList[index] && filterList[index][0]
        ? filterList[index][0].split(',').filter(Boolean)
        : [];
      return (
        <FormControl variant="standard" fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            multiple
            value={current}
            onChange={(e) => {
              const v = e.target.value;
              const csv = Array.isArray(v) ? v.filter(Boolean).join(',') : '';
              filterList[index] = csv ? [csv] : [];
              onChange(filterList[index], index, column);
            }}
            renderValue={(selected) => selected.map((s) => (valueRender ? valueRender(s) : s)).join(', ')}
          >
            {options.map((o) => (
              <MenuItem key={o} value={o}>{valueRender ? valueRender(o) : o}</MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    },
  },
});

// Satırın `tags[]` alanını rozetle çizer, süzgeç `tagId[in]` gönderir (SPEC F1 liste
// süzgeci). Katalog boşken süzgeç kapalı — seçeneksiz bir açılır liste anlamsız.
export const tagFilterColumn = (label, catalog) => {
  const items = Array.isArray(catalog) ? catalog : [];
  const byId = items.reduce((acc, tg) => ({ ...acc, [tg.id]: tg.name }), {});
  const filterPart = items.length > 0
    ? multiSelectFilter(label, items.map((tg) => tg.id), (id) => byId[id] || id, 'tagId[in]')
    : { filter: false };
  return {
    name: 'tags',
    label,
    options: {
      ...filterPart,
      sort: false,
      customBodyRender: (v) => <TagChips tags={v} />,
    },
  };
};
